import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { ReplaySubject, Subject } from 'rxjs';
import { MatSelect } from '@angular/material/select';
import { take, takeUntil } from 'rxjs/operators';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocomplete } from '@angular/material/autocomplete';
interface incubDis {
  district: string;
}
function restrictedCharsValidator(): ValidatorFn {
  return (control: FormControl): { [key: string]: any } | null => {
    const forbidden = /[^\sa-zA-Z]/.test(control.value);
    return forbidden ? { restrictedChars: { value: control.value } } : null;
  };
}

@Component({
  selector: 'app-corporate-profile',
  templateUrl: './corporate-profile.component.html',
  styleUrls: ['./corporate-profile.component.css'],
})
export class CorporateProfileComponent implements OnInit {
  documentForm: FormGroup;
  districtlistdata = new FormControl();
  documentsArray: any[] = [];
  corporateProfileForm: FormGroup;
  private saveApi = environment.url + environment.incubatorProfileSave;
  private getApi = environment.url + environment.incubatorProfileGet;
  private ProfilegetApi = environment.url + environment.profileGet;
  private csrProjectDocumentDeleteApi =
    environment.url + environment.csrProjectDocumentDelete;
  private sectorListApi = environment.url + environment.sectorList;
  ImageValue: string;
  img_name: any;
  imageFormat: any;
  oneImg_name: any;
  oneFileValue: any;
  image_url: any;
  oneImageValue: any;
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  sectorChipdataCtrl = new FormControl();
  filteredsectors: Observable<string[]>;
  sectors: string[] = [];
  allSectors: string[] = [];
  sector: string;
  districtlist: string[] = [];
  @ViewChild('sectorInput', { static: false })
  sectorInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto', { static: false }) matAutocomplete: MatAutocomplete;
  // end of chip data

  districtdataList: string[] = [
    'Ariyalur',
    'Chengalpattu',
    'Chennai',
    'Coimbatore',
    'Cuddalore',
    'Dharmapuri',
    'Dindigul',
    'Erode',
    'Kallakurichi',
    'Kanchipuram',
    'Kanniyakumari',
    'Karur',
    'Krishnagiri',
    'Madurai',
    'Mayiladuthurai',
    'Nagapattinam',
    'Namakkal',
    'Nilgiris',
    'Perambalur',
    'Pudukkottai',
    'Ramanathapuram',
    'Ranipet',
    'Salem',
    'Sivagangai',
    'Tenkasi',
    'Thanjavur',
    'Theni',
    'Thoothukudi',
    'Tiruchirappalli',
    'Tirunelveli',
    'Tirupathur',
    'Tiruppur',
    'Tiruvallur',
    'Tiruvannamalai',
    'Tiruvarur',
    'Vellore',
    'Viluppuram',
    'Virudhunagar',
    'Other',
  ];

  /**
   * Component constructor.
   * Initializes the component by creating the form group and
   * adding validators to the form controls.
   * @param route The route object.
   * @param router The router object.
   * @param fb The form builder object.
   * @param makeapi The API service object.
   * @param getdata The value service object.
   * @param notify The notify service object.
   * @param sanitizer The sanitizer object.
   * @param dialog The dialog object.
   * @param httpClient The HTTP client object.
   */
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    private sanitizer: DomSanitizer,
    public dialog: MatDialog,
    private httpClient: HttpClient
  ) {
    /**
     * The form group for the corporate profile page.
     * Contains the following fields: organizationName, incubatorRegDesc,
     * incubatorWebsite, incubatorYearofEstd, incubatorRegAddressLine1,
     * incubatorDistrict, incubatorOprState, incubatorOprCountry,
     * incubatorName, email, phone, ceoOrMdRegPhone, ceoOrMdRegEmail,
     * ceoOrMdRegName, incubatorTeamFirstName, incubatorTeamEmail,
     * incubatorTeamPhone, sector, incubatorOprInterestedDistricts,
     * documents, and incubatorLogoFileName.
     */
    this.corporateProfileForm = this.fb.group({
      organizationName: ['', [Validators.required]],
      incubatorRegDesc: ['', [Validators.required]],
      incubatorWebsite: ['', [Validators.required]],
      incubatorYearofEstd: ['', [Validators.required]],
      incubatorRegAddressLine1: ['', [Validators.required]],
      incubatorDistrict: [
        '',
        [Validators.required, restrictedCharsValidator()],
      ],
      incubatorOprState: [
        '',
        [Validators.required, restrictedCharsValidator()],
      ],
      incubatorOprCountry: ['', [Validators.required]],
      incubatorName: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      phone: [
        '',
        [
          Validators.required,
          Validators.pattern('^((\\+91-?)|0)?[0-9]{10,10}$'),
        ],
      ],
      ceoOrMdRegPhone: [
        '',
        [Validators.pattern('^((\\+91-?)|0)?[0-9]{10,10}$')],
      ],
      ceoOrMdRegEmail: ['', [Validators.required, Validators.email]],
      ceoOrMdRegName: ['', [Validators.required]],
      incubatorTeamFirstName: ['', [Validators.required]],
      incubatorTeamEmail: ['', [Validators.required, Validators.email]],
      incubatorTeamPhone: [
        '',
        [
          Validators.required,
          Validators.pattern('^((\\+91-?)|0)?[0-9]{10,10}$'),
        ],
      ],
      sector: [[], [Validators.required]],
      incubatorOprInterestedDistricts: [[], [Validators.required]],
      documents: new FormArray([]),
      incubatorLogoFileName: ['', [Validators.required]],
      incubatorcontryList: ['', [Validators.required]],
    });
    /**
     * The filtered sector list observable.
     * Filters the sector list based on the user input.
     */
    this.filteredsectors = this.sectorChipdataCtrl.valueChanges.pipe(
      startWith(),
      map((sector: string | null) =>
        sector ? this._filter(sector) : this.allSectors.slice()
      )
    );
  }
  get incubatorOprStateControl() {
    return this.corporateProfileForm.get('incubatorOprState');
  }
  get array() {
    return this.corporateProfileForm.get('documents') as FormArray;
  }
  /**
   * Called when the component is initialized.
   * Initializes the component by retrieving the sector list, the login profile,
   * and the profile of the user.
   * Also sets the visibility of the source section to true.
   * @returns {void}
   */
  ngOnInit(): void {
    // Retrieve the sector list
    this.sectorList();
    // Retrieve the login profile
    this.loginprofileget();
    // Set the visibility of the source section to true
    this.getdata.isVisibleSource.next(true);
    // Retrieve the list of years
    this.yearGetList();
    // Retrieve the list of states
    this.stateList();
    // Retrieve the list of districts
    this.districtList();
    // Retrieve the profile of the user
    this.profileGet();
    // Set the sector variable to 'Some Sector'
    this.sector = 'Some Sector';
    // Set the district list to some sample districts
    this.districtlist = ['District 1', 'District 2', 'District 3'];
    // Get the role and profile registration status from session storage
    this.roleValue = sessionStorage.getItem('role');
    this.proReg = sessionStorage.getItem('profileReg');
  }
  /**
   * Handles the event when the user types a new sector in the input field and
   * presses Enter or clicks on the Add button.
   * @param {MatChipInputEvent} event - The event containing the input field and
   * its value.
   * @returns {void}
   */
  addsector(event: MatChipInputEvent): void {
    // Check if the autocomplete is open
    if (!this.matAutocomplete.isOpen) {
      // Get the input field and its value
      const input = event.input;
      const value = event.value;

      // Check if the input field has a value
      if ((value || '').trim()) {
        // Add the value to the list of sectors
        this.sectors.push(value.trim());
      }

      // Clear the input field
      if (input) {
        input.value = '';
      }

      // Reset the sector chip data control value
      this.sectorChipdataCtrl.setValue(null);
    }
  }
  /**
   * Removes the specified sector from the list of selected sectors.
   * @param sector - The sector to remove from the list.
   * @returns {void}
   */
  removesector(sector: string): void {
    // Get the current list of selected sectors
    const toppings = this.sectorChipdataCtrl.value as string[];
    // Remove the specified sector from the list
    this.removeSetc(toppings, sector);
    // Update the sectorChipdataCtrl with the new list of selected sectors
    this.sectorChipdataCtrl.setValue(toppings);
  }
  /**
   * Removes the first occurrence of a specific element from an array.
   * @template T - The type of elements in the array.
   * @param {T[]} array - The array from which the element should be removed.
   * @param {T} toRemove - The element to remove from the array.
   * @returns {void}
   */
  removeSetc<T>(array: T[], toRemove: T): void {
    // Find the index of the element to remove
    const index = array.indexOf(toRemove);

    // If the element is found, remove it from the array
    if (index >= 0) {
      array.splice(index, 1);
    }
  }
  /**
   * Handles the event when a sector is selected from the autocomplete options.
   * Adds the selected sector to the list of sectors and resets the input field.
   * @param {MatAutocompleteSelectedEvent} event - The event containing the selected option.
   */
  selectedsector(event: MatAutocompleteSelectedEvent): void {
    // Add the selected sector to the sectors array
    this.sectors.push(event.option.viewValue);

    // Clear the input field for sector
    this.sectorInput.nativeElement.value = '';

    // Reset the sector chip data control value
    this.sectorChipdataCtrl.setValue(null);
  }
  /**
   * Filter the list of sectors based on the provided value.
   * The filter is case-insensitive and returns all sectors that contain the value.
   * @param {string} value - The value to filter the sectors by.
   * @returns {string[]} An array of sectors filtered by the value.
   */
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allSectors.filter(
      (sector) => sector.toLowerCase().indexOf(filterValue) === 0
    );
  }
  /**
   * Removes the first occurrence of a specific district from the list of districts.
   * Also updates the form control value if the list is empty.
   * @param {string} districtlist - The district to remove from the list.
   * @returns {void}
   */
  removedistrictlist(districtlist: string) {
    // Find the index of the district to remove
    const index = this.districtlistdata.value.indexOf(districtlist);

    // If the district is found, remove it from the array
    if (index !== -1) {
      const toppings = this.districtlistdata.value as string[];
      toppings.splice(index, 1);
      this.districtlistdata.setValue(toppings);

      // Update the form control value if the list is empty
      if (this.districtlistdata.value.length === 0) {
        let res = this.corporateProfileForm.value;
        res.incubatorOprInterestedDistricts = [];
        this.corporateProfileForm.patchValue(res);
      }
    }
  }
  /**
   * Removes the first occurrence of a specific element from an array.
   * @template T - The type of elements in the array.
   * @param {T[]} array - The array from which the element should be removed.
   * @param {T} toRemove - The element to remove from the array.
   * @returns {void}
   */
  removeFirst<T>(array: T[], toRemove: T): void {
    // Find the index of the element to remove
    const index = array.indexOf(toRemove);

    // If the element is found, remove it from the array
    if (index !== -1) {
      array.splice(index, 1);
    }
  }
  get add() {
    return this.corporateProfileForm.controls;
  }
  proReg: any;
  userData: any[] = [];
  addDocu: any = [];
  roleValue;
  setDocuments: any = [];
  newdistrict;
  corporateName;
  email;
  mobile;
  inputNotDisplay = false;
  sam;
  /**
   * Gets the profile data from the API and populates the form with the received data.
   * If the received data has a country, it sets the selected country to the received country.
   * If the received data has documents, it populates the form array with the documents.
   * If the received data has an incubator logo, it sets the image URL and image names.
   * If the received data has districts, it sets the district list.
   * @returns {void}
   */
  loginprofileget() {
    this.getdata.amizhthLoader('show');
    // Clear the form array
    while (this.array.length !== 0) {
      this.array.removeAt(0);
    }
    // Make the API call to get the profile data
    this.makeapi.method(this.getApi, '', 'get').subscribe((data) => {
      this.getdata.amizhthLoader('hide');
      // Set the country
      if (data.incubatorOprCountry === 'India') {
        data.incubatorcontryList = 'India';
      } else if (data.incubatorOprCountry === undefined) {
        data.incubatorcontryList = '';
      } else {
        data.incubatorcontryList = 'Other';
      }
      // Set the selected country
      if (data.incubatorOprCountry) {
        this.selectedCountry = data.incubatorOprCountry;
      }
      // Set the documents
      if (data.documents) {
        // Set the document names
        this.sam = data.documents.map((doc) => doc.documentName);
        // Add the documents to the form array
        data.documents.forEach((element) => {
          this.array.push(this.createItem());
        });
      } else {
        // Add a new form group to the array
        this.array.push(this.createItem());
      }
      // Set the image URL and image names
      if (data.incubatorLogoFileName !== null) {
        this.image_urls = data.incubatorLogoFileName;
        this.ImageValues = data.incubatorLogoFile;
        this.img_names = data.incubatorLogoFileName;
      } else {
        // Set the default image URL
        this.image_url = 'assets/images/photo.png';
      }
      // Set the districts
      this.newdistrict = data.incubatorOprInterestedDistricts;
      // Patch the form with the received data
      this.corporateProfileForm.patchValue(data);
      // Set the sector
      this.sectorChipdataCtrl.setValue(data.sector);
      // Set the district list
      this.districtlistdata.setValue(data.incubatorOprInterestedDistricts);
    });
  }

  /**
   * Adds a new document form group to the form array.
   * If the form array is invalid, it marks all the form controls as touched.
   * If the form array is valid, it adds a new form group to the array.
   * @returns {void}
   */
  newaddDocument() {
    if (this.array.invalid) {
      // Mark all the form controls as touched
      this.array.markAllAsTouched();
    } else {
      // Add a new form group to the array
      this.array.push(this.createItem());
    }
  }
  /**
   * Creates a new form group for a document.
   * The form group has three controls: id, documentName, and documentFile.
   * The id control is set to 0, documentName is required, and documentFile is not required.
   * @returns {FormGroup} A new form group for a document.
   */
  createItem(): FormGroup {
    return this.fb.group({
      id: [0],
      documentName: ['', [Validators.required]], // Document name is required
      documentFile: [''], // Document file is not required
    });
  }

  /**
   * Deletes a document from the database or removes an empty document field from the form array.
   * @param {number} i - The index of the document to be deleted.
   * @param {number} id - The id of the document to be deleted.
   * @returns {void}
   */
  deleteRow(i: number, id: number): void {
    // If the document has an id, delete it from the database
    if (id != 0) {
      this.makeapi
        .method(this.csrProjectDocumentDeleteApi + id, '', 'delete')
        .subscribe((data) => {
          if (data.responseStatus === 'Success') {
            this.notify.notifysuccess('Document Deleted Successfully');
            // Reload the form data
            this.loginprofileget();
          } else {
            this.notify.notifyError(data.responseMessage);
          }
        });
    } else {
      // If the document is empty, remove it from the form array
      if (i === 0) {
        // If the empty document is the first one, remove it and add a new one
        this.sliceRomove(i);
      } else {
        // If the empty document is not the first one, just remove it
        this.array.removeAt(i);
      }
    }
  }
  /**
   * Removes the element at the specified index in the form array and adds a new element to the end of the array.
   * @param {number} i - The index of the element to be removed.
   * @returns {void}
   */
  sliceRomove(i: number): void {
    // Remove the element at the specified index
    this.array.controls.splice(i, 1);

    // Add a new element to the end of the array
    this.array.push(this.createItem());
  }
  stateValue = [];
  statevalues;
  /**
   * Fetches the list of states from the assets/json/Indian.json file.
   * This is a static file that contains the list of states in India.
   * @returns {void}
   */
  stateList(): void {
    /**
     * The API endpoint to fetch the list of states
     * @type {string}
     */
    const url: string = 'assets/json/Indian.json';

    /**
     * Fetch the list of states from the API endpoint
     * @returns {Observable<any>}
     */
    this.httpClient.get<any>(url).subscribe((data: any) => {
      /**
       * The list of states
       * @type {any[]}
       */
      this.stateValue = data;

      /**
       * The list of districts in the selected state
       * @type {any[]}
       */
      this.statevalues = this.stateValue[0].states;
    });
  }
  selectedState: string = '';
  selectedCity: string = '';
  cities: any[] = [];
  /**
   * Handles the selection of a state from the dropdown.
   * @param state the selected state
   * @returns {void}
   */
  onSelectState(state: string): void {
    /**
     * Update the selected state
     * @type {string}
     */
    this.selectedState = state;

    /**
     * Find the selected state
     * @type {object}
     */
    const selectedStateData = this.statevalues.find(
      (s) => s.stateName === this.selectedState
    );

    /**
     * Update the list of cities
     * @type {array}
     */
    this.cities = selectedStateData.districts;

    /**
     * Clear the selected city
     * @type {string}
     */
    this.selectedCity = '';
  }
  districtValues = [];
  /**
   * Fetches the list of districts from the assets/json/district.json file.
   * This file contains a JSON object with all the districts in India.
   * @returns {void}
   */
  districtList(): void {
    /**
     * The API endpoint to fetch the list of districts
     * @type {string}
     */
    const url: string = 'assets/json/district.json';

    /**
     * Fetch the list of districts from the API endpoint
     */
    this.httpClient.get<any>(url).subscribe((data) => {
      /**
       * Set the districtValues variable to the data received from the API call
       */
      this.districtValues = data;

      /**
       * Set the incubatorDistrictList variable to the districtValues
       */
      this.incubatorDistrictList = this.districtValues;

      /**
       * Call the filterIncubetorDistrict function to filter the district list
       */
      this.filterIncubetorDistrict();
    });
  }
  yearData = [];
  /**
   * Populate the yearData list with the years from the current year to 1978.
   */
  yearGetList() {
    // Start year
    let val = 1978;
    // Get the current year
    const d = new Date();
    let year = d.getFullYear();
    // Loop through the years and add them to the list if they are greater than or equal to the start year
    for (let i = year; i >= val; i--) {
      if (val <= i) {
        this.yearData.push(i);
      }
    }
  }
  /**
   * Calls the API to get the list of sectors and updates the local list.
   */
  sectorList() {
    this.makeapi.method(this.sectorListApi, '', 'get').subscribe((data) => {
      // If the response from the API contains a list of sectors, update the local list
      if (data.sectors) {
        this.allSectors = data.sectors;
      }
    });
  }
  proFile;
  incubDis;
  selecetdFile: any = [];
  url: any;
  FileValue: any = '';
  FileName: any;
  documentValues = [];
  disName;
  selecetdRegFile: any = [];
  urlReg: any;
  RegFileValue: any = '';
  RegFileName: any;
  documentRegValues = [];
  RegdisName;
  docmentFormat;
  fileUploadedFlags: boolean[] = [];
  fileNameValue;
  /**
   * Handles the file upload for the registration document.
   * Validates the file type and size, reads the file as a data URL,
   * and updates the form with the uploaded file.
   * @param event The file upload event.
   * @param i The index of the file in the form array.
   */
  fileRegUpload(event, i) {
    this.selecetdRegFile = event.target.files[0];
    if (event.target.files && this.selecetdRegFile) {
      let reader = new FileReader();
      let fileType = this.selecetdRegFile.type;
      let fileExtension = fileType.split('/')[1];

      // Check if the file type is valid
      if (
        fileExtension === 'jpeg' ||
        fileExtension === 'jpg' ||
        fileExtension === 'png' ||
        fileExtension === 'pdf'
      ) {
        reader.readAsDataURL(this.selecetdRegFile);
        reader.onload = () => {
          this.urlReg = reader.result;
          let spl = this.urlReg.split(',');
          this.RegFileValue = spl[1];
          this.docmentFormat = spl[0].split('/');

          // Update the form with the file data
          let getform = this.array.value;
          getform[i].documentName = this.selecetdRegFile.name;
          getform[i].documentFile = spl[1];

          this.fileNameValue = this.selecetdRegFile.name;
          this.array.patchValue(getform);
          this.fileUploadedFlags[i] = true;
          this.fileNameValue = getform[i].documentName;
        };
      } else {
        let getform = this.array.value;
        getform[i].documentName = '';
        this.corporateProfileForm.controls['documents'].setErrors({
          required: true,
        });
        this.notify.notifyError(
          'Only *jpeg, *jpg, *png, *pdf formats are allowed'
        );
      }
    }
  }

  /**
   * Checks if the file name is a valid type.
   * @param {string} fileName the file name to check.
   * @returns {boolean} true if the file name is a valid type, false otherwise.
   */
  isFileTypeValid(fileName: string): boolean {
    // Supported file types
    const validExtensions = ['jpeg', 'jpg', 'png', 'pdf'];
    // Get the file extension from the file name
    const extension = fileName.split('.').pop().toLowerCase();
    // Check if the file extension is in the list of valid extensions
    return validExtensions.includes(extension);
  }

  /**
   * Submits the corporate profile form.
   * If the form is valid, it updates the corporate profile in the database.
   * If the form is invalid, it shows an error message to the user.
   * If the logo is not uploaded, it shows an error message to the user.
   */
  updateProfile() {
    let getform = this.corporateProfileForm.value;
    if (this.ImageValues == '' || this.corporateProfileForm.invalid) {
      // If the logo is not uploaded
      if (this.ImageValues == '') {
        this.logoCheck = true;
      }
      // Mark all the form controls as touched.
      // This will show the error messages to the user.
      this.corporateProfileForm.markAllAsTouched();
      // Show an error message to the user.
      this.notify.notifyError('Please fill all the mandatory fields !!');
      // Mark the documents form control as touched.
      this.corporateProfileForm.controls['documents'].markAsTouched();
    } else {
      // Show the loader.
      this.getdata.amizhthLoader('show');
      // If the logo is uploaded
      if (this.ImageValues != '') {
        // Add the logo file and file name to the form data.
        getform.incubatorLogoFile = this.ImageValues;
        getform.incubatorLogoFileName = this.img_names;
      }

      // Make the API call to update the corporate profile.
      this.makeapi.method(this.saveApi, getform, 'post').subscribe((data) => {
        // Hide the loader.
        this.getdata.amizhthLoader('hide');
        // If the API call is successful
        if (data.responseStatus == 'Success') {
          // Show a success message to the user.
          this.notify.notifysuccess(data.responseMessage);
          // Save the profile registration status in the session storage.
          sessionStorage.setItem('profileReg', 'Yes');
          // Remove the logo from the session storage.
          sessionStorage.removeItem('logo');
          // Navigate to the available projects page.
          this.router.navigateByUrl('/csrsavailproject');
          // Call the cancel event to reset the form.
          this.cancelEvent();
        } else {
          // If the API call fails
          // Mark the documents form control as invalid.
          this.corporateProfileForm.controls['documents'].setErrors({
            required: true,
          });
          // Mark the documents form control as touched.
          this.corporateProfileForm.controls['documents'].markAsTouched();
          // Show an error message to the user.
          this.notify.notifyError(data.responseMessage);
        }
      });
    }
  }
  /**
   * Cancels the profile editing event.
   * Resets the corporate profile form and navigates to the available projects page.
   */
  cancelEvent() {
    // Reset the form values to their initial state
    this.corporateProfileForm.reset();
    // Navigate to the CSR available projects page
    this.router.navigateByUrl('/csrsavailproject');
  }
  // year search
  protected incubatorDistrictList: incubDis[] = [];
  public incubatorDistrict: FormControl = new FormControl();
  public incubatorDistrictFilterCtrl: FormControl = new FormControl();
  public incubatorDistrictListValue = new ReplaySubject(1);
  protected _onDisDestroy = new Subject();
  @ViewChild('DistrictSelect', { static: true }) DistrictSelect: MatSelect;
  /**
   * Filters the incubator district list based on the user's input.
   * Subscribes to the value changes of the filter control and calls the filterDistrict function.
   */
  filterIncubetorDistrict() {
    /**
     * Set the default value of the district select control to the first element in the list
     */
    this.incubatorDistrict.setValue(this.incubatorDistrictList[1]);

    /**
     * Set the initial value of the incubator district list
     */
    this.incubatorDistrictListValue.next(this.incubatorDistrictList);

    /**
     * Subscribe to the value changes of the filter control
     * When the value changes, call the filterDistrict function
     */
    this.incubatorDistrictFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDisDestroy))
      .subscribe(() => {
        this.filterDistrict();
      });
  }
  /**
   * Sets the initial value of the incubator district select control.
   * Subscribes to the first value of the incubator district list value and sets the compareWith
   * function of the district select control to compare the incubator district strings.
   */
  protected setInitialIncubetorYear() {
    /**
     * Take the first value of the incubator district list value
     */
    this.incubatorDistrictListValue
      .pipe(
        // Take the first value of the incubator district list value
        take(1),
        // Automatically unsubscribe on component destroy
        takeUntil(this._onDisDestroy)
      )
      .subscribe(() => {
        /**
         * Compare the incubator district strings
         */
        this.DistrictSelect.compareWith = (a: incubDis, b: incubDis) =>
          a && b && a.district === b.district;
      });
  }
  /**
   * Filters the incubator district list based on the current value of the filter control.
   * If no search term is provided, returns the full list of incubator districts.
   * Otherwise, filters the list based on the search term and updates the list value.
   * @param event - The filter control value change event.
   */
  protected filterDistrict() {
    // Check if the incubator district list is available
    if (!this.incubatorDistrictList) {
      return;
    }

    // Get the current search term from the filter control
    const search = this.incubatorDistrictFilterCtrl.value;

    if (!search) {
      // If no search term is provided, return the full list of incubator districts
      this.incubatorDistrictListValue.next(this.incubatorDistrictList.slice());
      return;
    }

    // Convert the search term to lowercase for case-insensitive comparison
    const searchLower = search.toLowerCase();

    // Filter the incubator district list based on the search term and update the list value
    this.incubatorDistrictListValue.next(
      this.incubatorDistrictList.filter(
        (district) => district.district.toLowerCase().indexOf(searchLower) > -1
      )
    );
  }
  /**
   * Handles the selection change event for interested districts.
   * Updates the form control with the selected district values.
   * If no districts are selected, sets the value to null.
   * @param event - The selection change event containing the selected district values.
   */
  change(event) {
    let selectedDistricts = event.value;

    // Check if no districts are selected
    if (selectedDistricts.length === 0) {
      // If no districts are selected, set the value to null
      this.corporateProfileForm.value.incubatorOprInterestedDistricts = null;
    } else {
      // Otherwise, set the form control value to the selected districts
      this.corporateProfileForm.value.incubatorOprInterestedDistricts =
        selectedDistricts;
    }
  }

  /**
   * Handles the sector selection event.
   * Updates the form controls based on the selected sectors.
   * If the selected sectors is empty, it sets the value of the 'sector' control to null.
   * If the selected sectors is not empty, it sets the value of the 'sector' control to the selected sectors.
   * @param event - The selected sectors.
   */
  change1(event) {
    let sam = event.value;
    if (sam.length === 0) {
      // If the selected sectors is empty, set the value of the 'sector' control to null.
      this.corporateProfileForm.value.sector = null;
    } else {
      // If the selected sectors is not empty, set the value of the 'sector' control to the selected sectors.
      this.corporateProfileForm.value.sector = sam;
    }
  }
  selectedCountry: string;
  /**
   * Handles the country selection event.
   * Updates the form controls based on the selected country.
   * If the selected country is 'India', it sets the validators for the 'State' and 'District' controls.
   * If the selected country is not 'India', it clears the validators for the 'State' and 'District' controls.
   * @param country - The selected country.
   */
  onSelectCountry(country: string) {
    this.selectedCountry = country;
    if (country != 'India') {
      // Reset the country control if the selected country is not 'India'
      this.corporateProfileForm.get('incubatorOprCountry').reset();
    }
    if (country == 'India') {
      // Reset the state and district controls if the selected country is 'India'
      this.corporateProfileForm.get('incubatorOprState').reset();
      this.corporateProfileForm.get('incubatorDistrict').reset();
      // Set the validators for the 'State' and 'District' controls if the selected country is 'India'
      this.corporateProfileForm
        .get('incubatorDistrict')
        .setValidators([Validators.required, restrictedCharsValidator()]);
      this.corporateProfileForm
        .get('incubatorOprState')
        .setValidators([Validators.required, restrictedCharsValidator()]);
    } else {
      // Clear the validators for the 'State' and 'District' controls if the selected country is not 'India'
      this.corporateProfileForm.get('incubatorDistrict').clearValidators();
      this.corporateProfileForm.get('incubatorOprState').clearValidators();
    }
    // Update the value and validity of the 'State' and 'District' controls
    this.corporateProfileForm.get('incubatorDistrict').updateValueAndValidity();
    this.corporateProfileForm.get('incubatorOprState').updateValueAndValidity();
    // Set the value of the country control if the selected country is 'India'
    if (country == 'India') {
      this.add.incubatorOprCountry.setValue(country);
    }
  }
  ImageValues: any = [];
  imgFormat: any;
  selecetdImage: File;
  imagetype: any;
  fileValue: File;
  url1: any = 'assets/images/photo.png';
  img_names = '';
  image_urls: any = 'assets/images/photo.png';
  img: any;
  logoCheck = false;
  maxSizeMB = 10;
  /**
   * Handles the image selection event.
   * Validates the image size and type, and processes the valid image.
   * Updates image-related variables with the processed image data.
   * @param event - The event triggered when an image is selected.
   */
  onSelectImage(event) {
    // Select the first image from the file input
    this.selecetdImage = event.target.files[0];

    if (event.target.files && this.selecetdImage) {
      // Calculate the image size in MB
      const fileSizeMB = this.selecetdImage.size / (1024 * 1024);

      // Check if the image size exceeds the maximum allowed size
      if (fileSizeMB > this.maxSizeMB) {
        this.logoCheck = true; // Set flag if size exceeds limit
        return;
      }

      // Create a FileReader to read the image data
      const reader = new FileReader();
      const data = this.selecetdImage;
      this.imagetype = data.type;
      const imagedatatype = this.imagetype.split('/');
      const img_crt_type = imagedatatype[1];

      // Validate the image type
      if (
        img_crt_type === 'jpeg' ||
        img_crt_type === 'jpg' ||
        img_crt_type === 'png'
      ) {
        this.img = '';
        this.fileValue = this.selecetdImage;
        reader.readAsDataURL(this.fileValue);

        // Process the image when reading is complete
        reader.onload = () => {
          this.url1 = reader.result;
          const spl = this.url1.split(',');
          this.ImageValues = spl[1]; // Extract image data
          this.img_names = this.fileValue.name; // Set image name
          this.logoCheck = false; // Reset the check flag
          // Set the image URL and bypass security for the URL
          this.image_urls = this.sanitizer.bypassSecurityTrustResourceUrl(
            this.url1
          );
        };
      } else {
        // Notify the user if the image type is not valid
        this.img = 'show';
        this.notify.notifyError('Only *jpeg, *jpg, *png formats are allowed');
      }
    }
  }
  countrydef;
  showStateDistrict: boolean = false;
  showCountydummy: boolean = false;
  showdisthide: boolean = false;

  proFiles;
  /**
   * Fetches the profile data from the server using a GET request.
   * Updates the `image_urls` variable with the received profile image URL.
   * If the profile image does not exist, sets `image_urls` to the default user image.
   */
  profileGet() {
    let username = sessionStorage.getItem('username');
    this.makeapi
      .method(this.ProfilegetApi + '?username=' + username, '', 'get')
      .subscribe((data) => {
        this.proFiles = data;
        // Set the profile image URL to the received value
        if (data.incubatorLogoFileName != null) {
          this.image_urls = data.incubatorLogoFileName;
          this.ImageValues = data.incubatorLogoFile;
          this.img_names = data.incubatorLogoFileName;
        } else {
          // Set the profile image URL to the default user image
          this.image_urls = 'assets/images/photo.png';
        }
      });
  }

  textOnlyValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const textOnlyRegex = /^[a-zA-Z\s]*$/; // Regular expression to match alphabets and spaces
      if (control.value && !textOnlyRegex.test(control.value)) {
        return { textOnly: true }; // Validation error if input contains non-alphabetic characters
      }
      return null; // Validation passed
    };
  }
}
